import { render, staticRenderFns } from "./remarksModal.vue?vue&type=template&id=74e1ec67&scoped=true&"
import script from "./remarksModal.vue?vue&type=script&lang=js&"
export * from "./remarksModal.vue?vue&type=script&lang=js&"
import style1 from "./remarksModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e1ec67",
  null
  
)

export default component.exports